import { useEffect, useState } from "react";
import {
  Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  Divider, Grid, TextField, Typography,
} from "@mui/material";
import { adminApi } from "rsa/adminApi";

const EMPTY = {
  name: "", phone: "", email: "", address: "", pinCode: "",
  latitude: "", longitude: "",
  emergencyContactName: "", emergencyContactPhone: "",
};

export default function AddCustomerDialog({ open, onClose, onCreated }) {
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) { setForm(EMPTY); setError(""); }
  }, [open]);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async () => {
    setError("");
    if (!form.name.trim()) { setError("Name is required"); return; }
    if (form.phone.replace(/\D/g, "").length < 10) { setError("A 10-digit phone number is required — it's the customer's mobile app login"); return; }
    if ((form.latitude === "") !== (form.longitude === "")) { setError("Enter both latitude and longitude, or neither"); return; }
    setBusy(true);
    try {
      const customer = await adminApi("POST", "/admin/customers", form);
      onCreated(customer);
      onClose();
    } catch (e) {
      setError(e.status === 401 ? "Session expired — sign in again." : e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add customer</DialogTitle>
      <DialogContent dividers>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth required size="small" label="Name" value={form.name} onChange={set("name")} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth required size="small" label="Phone (10-digit)" value={form.phone} onChange={set("phone")}
              helperText="Used for customer OTP login on the mobile app" />
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth size="small" label="Email" value={form.email} onChange={set("email")} />
          </Grid>
          <Grid item xs={12} sm={9}>
            <TextField fullWidth size="small" label="Address" value={form.address} onChange={set("address")} />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField fullWidth size="small" label="PIN code" value={form.pinCode} onChange={set("pinCode")} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth size="small" label="Latitude (optional)" value={form.latitude} onChange={set("latitude")} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth size="small" label="Longitude (optional)" value={form.longitude} onChange={set("longitude")} />
          </Grid>
          <Grid item xs={12}><Divider><Typography variant="caption">Emergency contact</Typography></Divider></Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth size="small" label="Contact name" value={form.emergencyContactName} onChange={set("emergencyContactName")} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth size="small" label="Contact phone" value={form.emergencyContactPhone} onChange={set("emergencyContactPhone")} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>Cancel</Button>
        <Button variant="contained" onClick={submit} disabled={busy}>
          {busy ? "Creating…" : "Create customer"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
